import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a943c1a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-area-container" }
const _hoisted_2 = ["for"]
const _hoisted_3 = {
  key: 0,
  class: "required"
}
const _hoisted_4 = ["id", "cols", "rows", "maxlength", "placeholder", "value"]
const _hoisted_5 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          for: $props.id
        }, [
          _createElementVNode("span", null, _toDisplayString($props.label), 1 /* TEXT */),
          ($props.required)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, "*"))
            : _createCommentVNode("v-if", true)
        ], 8 /* PROPS */, _hoisted_2))
      : _createCommentVNode("v-if", true),
    _createElementVNode("textarea", {
      ref: "textareaRef",
      class: "wizdome-custom",
      id: $props.id,
      cols: $props.cols,
      rows: $props.rows,
      maxlength: $props.maxlength,
      placeholder: $props.placeholder,
      value: $props.value,
      onInput: $setup.onInput,
      onFocus: $setup.onFocus,
      onBlur: $setup.onBlurred
    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_4),
    ($props.maxlength)
      ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString($props.getTextAreaLength) + "/" + _toDisplayString($props.maxlength), 1 /* TEXT */))
      : _createCommentVNode("v-if", true)
  ]))
}